export default __webpack_public_path__ + "static/media/burj.bb1ddf58.png";